module.exports = __webpack_public_path__ + "img/34.7a1f8f25.jpg";